import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { cn as o } from "@tameeni/shared-logic";
import { Accordion as l, AccordionItem as n, AccordionTrigger as s, AccordionContent as c } from "./accordion.js";
import { Icon as a } from "@tameeni/icons";
function f(r) {
  return /* @__PURE__ */ e(l, { type: "single", collapsible: !0, className: "w-full flex flex-col gap-4", children: r.children });
}
function p(r) {
  return /* @__PURE__ */ t(
    n,
    {
      value: r.title,
      className: o(
        "group w-full px-4 rounded-lg border border-slate-200 bg-slate-50 data-[state=open]:bg-white data-[state=open]:drop-shadow",
        r.className
      ),
      children: [
        /* @__PURE__ */ t(
          s,
          {
            className: "flex flex-row items-center gap-4 py-4",
            removeIcon: !0,
            children: [
              /* @__PURE__ */ e("span", { className: "p-2 bg-white rounded-sm", children: /* @__PURE__ */ e(a, { name: "questionCircle", className: "size-5" }) }),
              /* @__PURE__ */ e("span", { className: "font-bold grow text-start", children: r.title }),
              /* @__PURE__ */ e("span", { className: "border rounded-full group-data-[state=open]:rotate-180 transition-all size-7 flex items-center justify-center", children: /* @__PURE__ */ e(a, { name: "ChevronDown", className: "size-3" }) })
            ]
          }
        ),
        /* @__PURE__ */ e(c, { className: "border-t border-slate-300 py-4 text-slate-600", children: r.children })
      ]
    }
  );
}
export {
  f as FaqAccordion,
  p as FaqItem
};
